import React from 'react';
import * as Styled from './styled';

const tripTopSkeleton = () => {
  return (
    <Styled.TripTopSkeletonWrapper>
      <Styled.TripTopSkeletonTopHeadWrapper>
        <Styled.TripTopSkeletonTopHead />
      </Styled.TripTopSkeletonTopHeadWrapper>
      <Styled.TripTopSkeletonTopFootWrapper>
        <Styled.TripTopSkeletonTopFoot />
      </Styled.TripTopSkeletonTopFootWrapper>
    </Styled.TripTopSkeletonWrapper>
  );
};

const tripStepSkeleton = firstUse => {
  return (
    <Styled.TripStepSkeletonWrapper>
      <Styled.TripStepSkeletonTopWrapper>
        <Styled.MiniCircleWrapper trailingLineHeight="100vh" top={firstUse}>
          <Styled.MiniCircleSkeleton />
        </Styled.MiniCircleWrapper>
        <Styled.TripStepSeparatorSkeleton />
      </Styled.TripStepSkeletonTopWrapper>
      <Styled.TripStepSkeletonMembers>
        <Styled.TripStepSkeletonOne />
      </Styled.TripStepSkeletonMembers>
      <Styled.TripStepSkeletonMembers>
        <Styled.TripStepSkeletonTwo />
      </Styled.TripStepSkeletonMembers>
    </Styled.TripStepSkeletonWrapper>
  );
};

function TripPlannerContainerSkeletons() {
  return (
    <>
      {tripTopSkeleton()}
      {tripStepSkeleton(true)}
      {tripStepSkeleton()}
      {tripStepSkeleton()}
    </>
  );
}

export default TripPlannerContainerSkeletons;
